import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Select from '../../Common/Select';

/**
 * Profiles form presentational component
 * Stores user input in state and submits input values
 */
export default class ProfilesForm extends PureComponent {
    static propTypes = {
        /**
         * User search profiles type
         */
        profilesType: PropTypes.string.isRequired,
        /**
         * User search query
         */
        query: PropTypes.string.isRequired,
        /**
         * Full list of profiles types (for profiles types dropdown)
         */
        profilesTypes: PropTypes.arrayOf(PropTypes.shape({
            /**
             * Profiles type identifier
             */
            value: PropTypes.string.isRequired,
            /**
             * Profiles type label (for displaying to user)
             */
            label: PropTypes.string.isRequired,
        })).isRequired,
        /**
         * Function to handle search
         */
        onSubmit: PropTypes.func.isRequired,
    }

    state = {
        profilesType: this.props.profilesType,
        query: this.props.query,
    }

    componentWillReceiveProps(nextProps) {
        const nextState = ['profilesType', 'query'].reduce((state, key) => {
            if (nextProps[key] !== this.props[key]) {
                return Object.assign({ [key]: nextProps[key] }, state);
            }
            return state;
        }, {});
        this.setState(nextState);
    }

    handleQueryChange = ev => this.setState({ query: ev.target.value })
    handleProfilesTypeChange = profilesType => this.setState({ profilesType })
    handleFormSubmit = (ev) => {
        ev.preventDefault();
        this.props.onSubmit(this.state);
    }

    render() {
        const { profilesTypes } = this.props;
        const { profilesType, query } = this.state;
        return (
            <form
                className="search-form"
                onSubmit={this.handleFormSubmit}
            >
                <input
                    id="search_page_search_form"
                    className="search-input ui-input"
                    placeholder="Search"
                    autoComplete="off"
                    value={query}
                    onChange={this.handleQueryChange}
                />
                <div className="search-select">
                    <Select
                        title="Profile Type"
                        options={profilesTypes}
                        value={profilesType}
                        onChange={this.handleProfilesTypeChange}
                    />
                </div>
                <div className="search-search">
                    <button
                        className="search-button ui-btn ui-btn_primary"
                        type="submit"
                    >
                        Search
                    </button>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Profiles/components/ProfilesForm.jsx